import { twMerge } from 'tailwind-merge';

/**
 * className joiner with Tailwind conflict resolution: falsy values are dropped and later utilities win over
 * earlier ones of the same group (`cn('px-4 py-4', 'p-0')` → `p-0`), so `className` overrides on shared
 * components always apply regardless of CSS order. Project tokens (bg-surface-2, text-2xs, text-muted…) are
 * classified correctly by tailwind-merge's defaults.
 */
export function cn(...parts: (string | false | null | undefined | 0)[]): string {
  return twMerge(parts.filter(Boolean) as string[]);
}
